import React, { FC, useEffect } from 'react';
import translate from '@translate';
import { useDispatch } from 'react-redux';
import { setLocationParams } from 'src/resources/location/reducer';
import Button from 'src/components/Button';
import { useNavigate } from 'react-router-dom';
import { useCheckPermission } from 'src/utils/checkPermission';
import TopBlockAdmin from '../AdminContainer/TopBlock';
import { SettingsIcon } from 'src/components/SkladonIcon/SmallIcons';

const SystemContainer: FC = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(setLocationParams({ name: translate('system.title') }));
    }, []);

    const handleClickConfig = () => {
        navigate('/admin/system/config');
    };

    const permissionConfig = useCheckPermission('SYSTEM_CONFIG.DETAIL');

    return (
        <>
            <TopBlockAdmin />
            {permissionConfig && (
                <Button onClick={handleClickConfig} sx={{ '& svg': { marginLeft: '10px' } }}>
                    {translate('system.config')} <SettingsIcon />
                </Button>
            )}
        </>
    );
};

export default SystemContainer;
